import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import blacklist from 'blacklist'

const InputSwitch = ({onChange,checked = false, name, className}) => {

const handleClick = () =>  onChange(!checked)

const extraProps = blacklist(
  'className',
  'checked',
  'onChange',
  'name'
)

const classNameParsed = cx(
  'u-switch',
  {
    'is-checked': checked,
  },
  className
)

return (
  <label
  className={classNameParsed}
  onClick={handleClick}
  {...extraProps} >
    <input type='hidden' name={name} value={checked ? 'yes' : 'no'} />
    <span className='track' />
    <span className='inputSButton' />
  </label>
  )

}

InputSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
}

export default InputSwitch
